module.exports = __webpack_public_path__ + "static/media/over5.53e80a07.jpg";